<template>
  <div class="content">
    <div class="layout">
      <div class="text-end mb-3">
        <select
          v-model="selectedLang"
          @change="onLangChange"
          class="form-select w-auto d-inline-block"
        >
          <option v-for="lang in languages" :key="lang.code" :value="lang.code">
            {{ lang.language }}
          </option>
        </select>
        <select
          v-model="selectedCountry"
          @change="onCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
      </div>

      <div class="text-end mb-2">
        <button class="btn btn-success" @click="openAddContactModal">
          Add Contact
        </button>
      </div>

      <div style="overflow-x: auto">
        <table class="table">
          <thead class="thead-dark">
            <tr>
              <th>Calls</th>
              <th>Email</th>
              <th>Whatsapp</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(contact, index) in contacts"
              :key="index"
              class="align-items-center"
            >
              <td>{{ contact.msisdn || "Null" }}</td>
              <td>{{ contact.email || "Null" }}</td>
              <td>{{ contact.whatsapp || "Null" }}</td>
              <td class="text-end">
                <button
                  class="btn btn-warning mr-1"
                  @click="editContact(contact)"
                >
                  Update
                </button>
                <button
                  class="btn btn-danger ml-1"
                  @click="deleteContact(contact.id)"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Update Contact Modal -->
      <div v-if="showUpdateContactModal" class="modal-overlay">
        <div class="modal-content">
          <span class="close" @click="closeModal">&times;</span>
          <h2>Edit Contact</h2>
          <input
            class="form-control my-1"
            v-model="currentContact.msisdn"
            placeholder="Phone Number"
          />
          <input
            class="form-control my-1"
            v-model="currentContact.email"
            placeholder="Email address"
          />
          <input
            class="form-control my-1"
            v-model="currentContact.whatsapp"
            placeholder="Whatsapp Number"
          />
          <div class="modal-footer">
            <button class="btn btn-primary my-3" @click="updateContact">
              Update
            </button>
          </div>
        </div>
      </div>

      <!-- Add Contact Modal -->
      <div v-if="showAddContactModal" class="modal-overlay">
        <div class="modal-content">
          <span class="close" @click="closeModal">&times;</span>
          <h2>Add Contact</h2>
          <input
            class="form-control my-1"
            v-model="currentContact.msisdn"
            placeholder="Phone Number"
          />
          <input
            class="form-control my-1"
            v-model="currentContact.email"
            placeholder="Email address"
          />
          <input
            class="form-control my-1"
            v-model="currentContact.whatsapp"
            placeholder="Whatsapp Number"
          />
          <div class="modal-footer">
            <button class="btn btn-primary my-3" @click="addContact">
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      selectedLang: "en",
      selectedCountry: "CG",
      showAddContactModal: false,
      showUpdateContactModal: false,
      contacts: [],
      languages: [],
      countries: [],
      currentContact: {
        msisdn: "",
        email: "",
        whatsapp: "",
        language: "en",
        country: "CG",
      },
    };
  },
  watch: {
    selectedLang(newLang) {
      this.getContacts(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.getContacts(this.selectedLang, newCountry);
    },
  },
  async mounted() {
    await this.getLanguages();
    await this.getCountries();

    // Ensure selectedCountry is valid after countries load
    if (!this.selectedCountry && this.countries.length) {
      this.selectedCountry = this.countries[0].code;
    }

    this.getContacts(this.selectedLang, this.selectedCountry);
  },
  methods: {
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });
        if (response.status === 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getCountries() {
  try {
    const response = await axios.get(`countries`, {
      headers: {
        "api-key": Cookies.get("authToken"),
      },
    });

    if (response.status === 200 && Array.isArray(response.data.countries)) {
      this.countries = response.data.countries;

      // 👇 ensure selected country exists
      if (
        !this.selectedCountry ||
        !this.countries.some(c => c.code === this.selectedCountry)
      ) {
        this.selectedCountry = this.countries[0].code;
      }
    } else {
      this.countries = [];
    }
  } catch (error) {
    this.handleError(error);
  }
},
async getContacts(lang, country) {
  try {
    const response = await axios.get(
      `/contacts?lang=${lang}&country=${country}`,
      {
        headers: {
          "api-key": `${Cookies.get("authToken")}`,
        },
      }
    );

    if (response.status === 200) {
      // ✅ FORCE ARRAY
      this.contacts = Array.isArray(response.data)
        ? response.data
        : [response.data];
    }
  } catch (error) {
    this.handleError(error);
  }
},

    openAddContactModal() {
      this.resetCurrentContact();
      this.showAddContactModal = true;
    },
    resetCurrentContact() {
      this.currentContact = {
        msisdn: "",
        email: "",
        whatsapp: "",
        language: this.selectedLang,
        country: this.selectedCountry,
      };
    },
    closeModal() {
      this.showAddContactModal = false;
      this.showUpdateContactModal = false;
      this.resetCurrentContact();
    },
    async addContact() {
      try {
        // Update language and country in contact
        this.currentContact.language = this.selectedLang;
        this.currentContact.country = this.selectedCountry;

        // Basic validation
        if (
          !this.currentContact.msisdn ||
          !this.currentContact.email ||
          !this.currentContact.whatsapp
        ) {
          this.$notify({
            message: "Please fill all contact fields.",
            type: "warning",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return;
        }

        const response = await axios.post("/contacts", this.currentContact, {
          headers: {
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        if (response.status === 201) {
          this.$notify({
            message: "Successfully created",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.getContacts(this.selectedLang, this.selectedCountry);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.closeModal();
      }
    },
    editContact(contact) {
      this.currentContact = { ...contact };
      this.showUpdateContactModal = true;
    },
    async updateContact() {
      try {
        this.currentContact.language = this.selectedLang;
        this.currentContact.country = this.selectedCountry;

        if (
          !this.currentContact.msisdn ||
          !this.currentContact.email ||
          !this.currentContact.whatsapp
        ) {
          this.$notify({
            message: "Please fill all contact fields.",
            type: "warning",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          return;
        }

        const response = await axios.post("/contacts", this.currentContact, {
          headers: {
            "api-key": `${Cookies.get("authToken")}`,
          },
        });
        if (response.status === 201 || response.data.status === 201) {
          this.$notify({
            message: "Contact updated successfully",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.getContacts(this.selectedLang, this.selectedCountry);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.closeModal();
      }
    },
    async deleteContact(id) {
      try {
        const response = await axios.delete(`/contacts/${id}`, {
          headers: {
            "api-key": `${Cookies.get("authToken")}`,
          },
        });
        if (response.status === 200) {
          this.$notify({
            message: "Successfully deleted",
            type: "success",
            horizontalAlign: "right",
            verticalAlign: "top",
          });
          this.getContacts(this.selectedLang, this.selectedCountry);
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    onLangChange() {
      this.getContacts(this.selectedLang, this.selectedCountry);
    },
    onCountryChange() {
      this.getContacts(this.selectedLang, this.selectedCountry);
    },
    handleError(error) {
      const message =
        error.response?.data?.message || error.response?.data?.error_message;
      const status = error.response?.status;

      if (status === 401) {
        this.$notify({
          message: "Session expired, please login",
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
        Cookies.remove("authToken");
        this.$router.push("/login");
      } else {
        this.$notify({
          message: message || "An error occurred",
          type: "danger",
          horizontalAlign: "right",
          verticalAlign: "top",
        });
      }
    },
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 300px;
  max-width: 90%;
  text-align: center;
  position: relative;
}

.close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}
</style>
